import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { DayTranslatePipe } from './dayTranslate.pipe';

@NgModule({
  declarations: [DayTranslatePipe], 
  imports: [CommonModule],
  exports: [DayTranslatePipe]
})
export class DayTranslatePipeModule  {}